import React, { Fragment } from 'react';
import Collapsible from 'react-collapsible';

import { ReactComponent as ArrowDown } from '../../assets/arrow-down.svg';

import { ConsentHistoryActionSourceTypeDanish, ConsentHistoryActorTypeDanish } from '../../helpers/EnumsDanish';


function OwnerConsentHistory(props: any) {
    let { hist } = props;

    return (
        <Collapsible open={ false }
            triggerClassName="col-12 accordion"
            transitionTime={400} easing={'ease-in-out'}
            triggerOpenedClassName="col-12 accordion active"
            triggerTagName='div'
            trigger={
                <div className="col-12 accordion">
                    <p className="show">Vis historik</p>
                    <p className="hide">Skjul historik</p>
                    <span className="toggle-icon"><ArrowDown /></span>
                </div>
            }
        >
            { hist.map((hist: any, index: number) => (
                <Fragment key={index}>
                    <span className={(hist.isRevokedAction ? 'consentInactive' : 'consentActive') }
                        title={"Kilde: " + (hist.stakeholder ? hist.stakeholder : ConsentHistoryActionSourceTypeDanish[hist.actionSourceType])}>
                        {new Date(hist.createDateTime).toLocaleString('en-DK').replace(',', '')}: { hist.isRevokedAction ? 'Tilbagekaldt' : 'Oprettet' } p&aring; Mitsamtykke
                            ({ hist.stakeholder ? hist.stakeholder : ConsentHistoryActorTypeDanish[hist.actorType] })
                    </span><br />
                </Fragment>
            ))}
        </Collapsible>
    );
}

export default OwnerConsentHistory
